import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/pro-light-svg-icons'

import { generateApplicationUrl } from '@domain-group/javascript-utils'

import {
  Button, DashboardModule, Form, Text,
} from '@domain-group/suit-theme'

import { useUserForm } from '@hooks/useUser'

import timeZones from '@functions/timeZones'

interface UserDetailsProps {
  userFormPayload: ReturnType<typeof useUserForm>,
  realbaseId: number,
}

const UserDetails = (props: UserDetailsProps) => {
  const {
    userFormPayload: {
      entityState: {
        email,
        first_name,
        last_name,
        time_zone,
      },
      errors,
      handlers,
    },
    realbaseId,
  } = props

  // This will need to be added in again when we update the flow to edit details in realbase
  //
  // const applicationUrlPayload = generateApplicationUrl({
  //   applicationKey: 'realbase',
  //   environment: process.env.REACT_APP_APPLICATION_ENV,
  //   hash: `/#/account/users/${realbaseId}/edit/`,
  //   redirectUrl: window.location.hash,
  // })
  // const { applicationUrlWithHash } = applicationUrlPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Name and Contact">
      <Form padding="large">
        <Text color="faintGrey" fontSize="xsmall" lineHeight={1.3}>
          Your name will be used to identify you and your actions across the platform as well as allow you to communicate with other members of your team on artwork proofs and other conversations.
        </Text>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.first_name} label="* First Name">
            <input name="first_name" type="text" value={first_name} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2339 */}
          <Form.Field errorMessage={errors.last_name} label="* Last Name" marginTop={['large', 0]}>
            <input name="last_name" type="text" value={last_name} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.email} label="* Email">
            <input name="email" type="text" value={email} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2339 */}
          <Form.Field errorMessage={errors.time_zone} label="* Timezone" marginTop={['large', 0]}>
            {/*
             // @ts-expect-error TS2322 */}
            <select value={time_zone} {...handlers}>
              {timeZones.map(timezone => (
                <option key={timezone.key} value={timezone.value}>
                  {timezone.title}
                </option>
              ))}
            </select>
          </Form.Field>
        </Form.Row>

        <Text color="faintGrey" fontSize="xsmall" lineHeight={1.3} marginTop="medium">
          Your email address will be used to send notifications such as artwork proofing or media delivery.
        </Text>
      </Form>

      {/* {!!realbaseId && (
        <DashboardModule.Footer boxProps={{ borderTop: '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faEdit} />}
              as="a"
              href={applicationUrlWithHash}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Edit in Realbase
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      )} */}
    </DashboardModule>
  )
}

export default UserDetails
